/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Overlay Controls
import { NgcTooltipModule } from '../controls/tooltip/ngc-tooltip.component';

/**
 * NGC Overlay Module
 */
@NgModule({
    exports: [
        NgcTooltipModule
    ]
})
export class NgcOverlayModule {
}